module.exports = __webpack_public_path__ + "img/run_left.b1e5ffbc.jpg";